import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import initial from "lodash/initial";
import last from "lodash/last";
import reduce from "lodash/reduce";
import map from "lodash/map";
import { SubmissionError } from "redux-form";

const superagent = superagentPromise(_superagent, global.Promise);

const ROOT =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_API_ROOT || ""
        : "http://localhost:3000";

const API_ROOT = ROOT + "/api";

const responseBody = res => res.body;

let token = null;
const tokenPlugin = req => {
    if (token) {
        req.set("authorization", `Token ${token}`);
    }
};

const formatErrors = errors =>
    reduce(
        errors,
        (acc, error, key) => {
            const subkeys = key.split(".");
            const ref = initial(subkeys).reduce((ref, subkey) => {
                if (!(subkey in ref)) {
                    ref[subkey] = {};
                }
                ref = ref[subkey];
                return ref;
            }, acc);
            ref[last(subkeys)] = error;
            return acc;
        },
        {}
    );

export class AuthError {}

const responseError = err => {
    let msg = "";

    if (err.response) {
        try {
            const customErr = JSON.parse(err.response.text);
            const { errors: { message = "" } = {} } = customErr;
            msg = message;
        } catch (e) {
            console.log(e);
        }
    }

    let data = {
        source: "SERVER",
        message: err.response
            ? `${err.response.error.message} | ${msg}`
            : `request terminated`,
        code: err.status,
        errorStack: err.stack
    };

    CustomError.add(data);

    switch (err.status) {
        case 400:
            return Promise.reject(new Error("Сервер не ответил вовремя"));
        case 401:
            return Promise.reject(new AuthError());
        case 403:
            return Promise.reject(new Error("Нарушение прав доступа"));
        case 408:
            return Promise.reject(new Error(err.response.body.message));
        case 422:
            return Promise.reject(
                new SubmissionError(formatErrors(err.response.body.errors))
            );
        case 500:
            return Promise.reject(
                new Error(
                    err.response
                        ? `${err.response.error.message} | ${msg}`
                        : `request terminated`
                )
            );
        default:
            return Promise.reject(new Error(err));
    }
};

const requests = {
    del: url =>
        superagent
            .del(`${API_ROOT}${url}`)
            .use(tokenPlugin)
            .then(responseBody)
            .catch(responseError),
    get: url =>
        superagent
            .get(`${API_ROOT}${url}`)
            .use(tokenPlugin)
            .then(responseBody)
            .catch(responseError),
    put: (url, body) =>
        superagent
            .put(`${API_ROOT}${url}`, body)
            .use(tokenPlugin)
            .then(responseBody)
            .catch(responseError),
    post: (url, body) =>
        superagent
            .post(`${API_ROOT}${url}`, body)
            .use(tokenPlugin)
            .then(responseBody)
            .catch(responseError),
    upload: (url, name, files, onProgress = ev => {}) => {
        const req = superagent.post(`${API_ROOT}${url}`);
        files.forEach(file => req.attach(name, file));
        req.on("progress", ev => ev.direction === "upload" && onProgress(ev));
        return req
            .use(tokenPlugin)
            .then(responseBody)
            .catch(responseError);
    }
};

export const shutdown = () =>
    superagent
        .get(`${ROOT}/shutdown`)
        .use(tokenPlugin)
        .catch(() => window.location.replace("https://www.google.com"));

export const Auth = {
    current: () => requests.get("/user"),
    login: (email, password) =>
        requests.post("/users/login", { user: { email, password } }),
    register: user => requests.post("/users", { user }),
    save: user => requests.put("/user", { user })
};

const encodeConditions = conditions =>
    map(conditions, (value, key) =>
        Array.isArray(value)
            ? value.map(v => `${key}[]=${encodeURIComponent(v)}`).join("&")
            : `${key}=${encodeURIComponent(value)}`
    ).join("&");

export const Clients = {
    checkTerrorist: query => requests.post("/client/terrorist", { query }),
    create: client => requests.post("/client", { client }),
    all: conditions =>
        requests.get(`/clients/get?` + encodeConditions(conditions)),
    fsspinfo: (firstname, lastname, patronymic, birthDate) =>
        requests.post(`/client/fsspinfo/`, {
            firstname,
            lastname,
            patronymic,
            birthDate
        }),
    setStatus: (id, status) =>
        requests.post("/client/status", { client: { id, status } }),
    submitDraft: (carId, data) =>
        requests.post("/client/draft", { carId, data }),
    denyLoan: (id, data) => requests.post("/client/deny", { id, data }),
    setSecurityDetails: (carId, data) =>
        requests.post("/client/security", { carId, data }),
    editClient: (id, details) =>
        requests.post(`/client/${id}/edit`, { client: { id, details } }),
    editCar: (id, details) =>
        requests.post(`/client/${details.client}/editcar/${id}/edit`, {
            client: { id, details }
        }),
    addComment: (id, details) =>
        requests.post(`/client/comment`, { id, details }),
    deleteComment: (carId, commentId) =>
        requests.post(`/client/deletecomment`, { carId, commentId }),
    setVisitTime: id => requests.post(`/client/visit`, { client: { id } }),
    tradeSubmit: (carId, data) =>
        requests.post(`/client/tradesubmit`, { carId, data }),
    tradeCar: (carId, data) => requests.post(`/client/trade`, { carId, data }),
    tradeStatus: (carId, status) =>
        requests.post(`/client/tradestatus`, { carId, status }),
    duplicateClient: car => requests.post(`/client/duplicate`, { car }),
    archiveClient: id => requests.post(`/client/archive`, { client: { id } }),
    sendSMS: (id, details) =>
        requests.post(`/client/sms`, { client: { id, details } }),
    FNPRequset: (vin, sessionID, data) =>
        requests.post(`/client/fnp`, { vin, sessionID, data }),
    bankruptRequset: data => requests.post(`/client/bankrupt`, { data }),
    requestKADInfo: data => requests.post(`/client/kad`, { data }),
    FNPHistory: (uuid, sessionID) =>
        requests.post(`/client/fnphistory`, { uuid, sessionID }),
    nkbiRequest: (carId, clientDetails) =>
        requests.post(`/client/nkbirequest`, { carId, ...clientDetails }),
    nkbiFetch: (carId, requestId) =>
        requests.post(`/client/nkbifetch`, { carId, requestId }),
    cronosRequest: (
        carId,
        clientDetails,
        { passportScanFile, confirmFile }
    ) => {
        const {
            lastname,
            firstname,
            patronymic,
            birthDate,
            address = "...",
            passportSerie,
            passportNumber
        } = clientDetails;
        const req = superagent
            .post(`${API_ROOT}/client/cronosrequest`)
            .field("carId", carId)
            .field("lastname", lastname)
            .field("firstname", firstname)
            .field("patronymic", patronymic)
            .field("birthDate", birthDate)
            .field("address", address)
            .field("passportSerie", passportSerie)
            .field("passportNumber", passportNumber)
            .attach("passportScanFile", passportScanFile)
            .attach("confirmFile", confirmFile);
        return req
            .use(tokenPlugin)
            .then(responseBody)
            .catch(responseError);
    },
    cronosFetch: (carId, requestId) =>
        requests.post(`/client/cronosfetch`, { carId, requestId })
};

export const Contract = {
    get: id => requests.get(`/contract/${id}`),
    all: conditions =>
        requests.get("/contracts/get?" + encodeConditions(conditions)),
    getSuggestions: query => requests.get(`/contract/suggestions/${query}`),
    setClientDetails: ({ carId, carNumber, clientId }, clientDetails) =>
        requests.post(`/contract/client`, {
            carId,
            carNumber,
            clientId,
            clientDetails
        }),
    setCarDetails: (contractId, carDetails) =>
        requests.post(`/contract/car`, { contractId, carDetails }),
    setProgramDetails: (contractId, programDetails) =>
        requests.post(`/contract/program`, { contractId, programDetails }),
    setContractStatus: (contractId, status) =>
        requests.post(`/contract/status`, { contractId, status }),
    sign: (contractId, signDetails, transactions) =>
        requests.post(`/contract/sign`, {
            contractId,
            signDetails,
            transactions
        }),
    prolongate: (contractId, data, transactions) =>
        requests.post(`/contract/prolongate`, {
            contractId,
            data,
            transactions
        }),
    increase: (contractId, oldSum, data, transactions) =>
        requests.post(`/contract/increase`, {
            contractId,
            oldSum,
            data,
            transactions
        }),
    repay: (contractId, oldSum, data, transactions) =>
        requests.post(`/contract/repay`, {
            contractId,
            oldSum,
            data,
            transactions
        }),
    close: (contractId, data, transactions) =>
        requests.post(`/contract/close`, { contractId, data, transactions }),
    bankrupt: (contractId, isBankrupt) =>
        requests.post(`/contract/bankrupt`, { contractId, isBankrupt }),
    edit: (contractId, data) =>
        requests.post(`/contract/edit`, { contractId, data }),
    setDebt: (contractId, data) =>
        requests.post(`/contract/debt`, { contractId, data }),
    setStats: (clientId, data) =>
        requests.post(`/contract/stats`, { clientId, data }),
    addFSSPCheck: (contractId, check) =>
        requests.post(`/contract/fsspcheck`, { contractId, check }),
    addGIBDDCheck: (contractId, check) =>
        requests.post(`/contract/gibddcheck`, { contractId, check }),
    addTerrorCheck: (contractId, check) =>
        requests.post(`/contract/terrorcheck`, { contractId, check }),
    addGPSNote: (contractId, data) =>
        requests.post(`/contract/gpsnote`, { contractId, data }),
    setGPSStatus: (contractId, status) =>
        requests.post(`/contract/gpsstatus`, { contractId, status }),
    addLoanNumber: (contractId, data) =>
        requests.post(`/contract/loannumber`, { contractId, data }),
    resolveProblem: (table, checkId) =>
        requests.post(`/contract/resolve`, { table, checkId }),
    penaltyUnfreeze: (contractId, data) =>
        requests.post(`/contract/unfreeze`, { contractId, data }),
    penaltyFreeze: (contractId, data) =>
        requests.post(`/contract/freeze`, { contractId, data })
};

export const Client = {
    get: id => requests.get(`/client/${id}`),
    uploadDoc: (id, carId, name, files, onProgress) =>
        requests.upload(
            `/client/${id}/car/${carId}/upload`,
            name,
            files,
            onProgress
        ),
    deleteDoc: (id, carId, doc) =>
        requests.del(`/client/${id}/car/${carId}/doc/${doc}`)
};

export const User = {
    get: id => requests.get(`/user/${id}`),
    deleteById: id => requests.post(`/user/delete`, { id }),
    editUser: (id, data) =>
        requests.post(`/user/${id}/edit`, { user: { id, data } }),
    all: () => requests.get(`/users`),
    managers: personType =>
        requests.post(`/managers`, { user: { personType } }),
    sendMessage: (id, data) =>
        requests.post(`/user/feedback`, { user: { id, data } }),
    getLoans: id => requests.post(`/user/loans`, { user: { id } }),
    changePassword: (id, data) =>
        requests.post(`/user/password`, { user: { id, data } })
};

export const Websocket = {
    sign: (contractId, office, manager, transactions) =>
        requests.post(`/ws/sign`, {
            contractId,
            office,
            manager,
            transactions
        }),
    close: (contractId, office, manager, transactions) =>
        requests.post(`/ws/close`, {
            contractId,
            office,
            manager,
            transactions
        }),
    penalty: (contractId, office, manager, transactions) =>
        requests.post(`/ws/penalty`, {
            contractId,
            office,
            manager,
            transactions
        }),
    prolongate: (contractId, office, manager, transactions) =>
        requests.post(`/ws/prolongate`, {
            contractId,
            office,
            manager,
            transactions
        }),
    cashIncome: (office, device, data) =>
        requests.post(`/ws/income`, { office, device, data }),
    closeShift: (office, device) =>
        requests.post(`/ws/shift`, { office, device }),
    getStatus: () => requests.get(`/ws/status`)
};

export const Cars = {
    brands: () => requests.get("/cars/brands"),
    extra: () => requests.get("/cars/extra"),
    models: brand => requests.get(`/cars/models/${brand}`)
};

export const Reports = {
    get: () => requests.get(`/reports`),
    generateReport: (startDate, endDate) =>
        requests.post(`/reports/report1`, { startDate, endDate }),
    generateReport2: (startDate, endDate) =>
        requests.post(`/reports/report2`, { startDate, endDate }),
    generateReport3: (startDate, endDate) =>
        requests.post(`/reports/report3`, { startDate, endDate }),
    generateReport4: (startDate, endDate) =>
        requests.post(`/reports/report4`, { startDate, endDate }),
    generateReport5: () => requests.post(`/reports/report5`),
    generateReport6: (programs, statuses) =>
        requests.post(`/reports/report6`, { programs, statuses }),
    upload: (name, files, onProgress) =>
        requests.upload(`/reports/upload`, name, files, onProgress),
    delete: id => requests.del(`/reports/delete/${id}`)
};

export const Log = {
    all: filters => requests.get(`/logs?${encodeConditions(filters)}`)
};

export const Transactions = {
    all: filters => requests.get(`/transactions?${encodeConditions(filters)}`),
    getByContract: contractId =>
        requests.get(`/transactions/contract/${contractId}`),
    getByCredit: creditId => requests.get(`/transactions/credit/${creditId}`),
    add: transaction => requests.post("/transactions/add", { transaction }),
    edit: (id, transaction) =>
        requests.post("/transactions/edit", { id, transaction }),
    delete: id => requests.del(`/transactions/delete/${id}`),
    import: transactions =>
        requests.post("/transactions/import", { transactions }),
    transfer: transaction =>
        requests.post("/transactions/transfer", { transaction }),
    balance: () => requests.get("/transactions/balance"),
    generateReport: (startDate, endDate) =>
        requests.post("/transactions/report", { startDate, endDate })
};

export const Operation = {
    getAll: () => requests.get(`/operations`),
    create: data => requests.post(`/operations/create`, { data }),
    edit: (id, data) => requests.post(`/operations/edit/${id}`, { data }),
    delete: id => requests.del(`/operations/delete/${id}`)
};

export const OperationGroup = {
    getAll: () => requests.get(`/operationgroup`),
    create: data => requests.post(`/operationgroup/create`, { data }),
    delete: id => requests.del(`/operationgroup/delete/${id}`)
};

export const OperationSubgroup = {
    getAll: () => requests.get(`/operationsubgroup`),
    getGrouped: () => requests.get(`/operationsubgroup/grouped`),
    create: data => requests.post(`/operationsubgroup/create`, { data }),
    delete: id => requests.del(`/operationsubgroup/delete/${id}`)
};

export const Account = {
    getAll: () => requests.get(`/accounts`),
    getGrouped: () => requests.get(`/accounts/grouped`),
    create: data => requests.post(`/accounts/create`, { data }),
    delete: id => requests.del(`/accounts/delete/${id}`)
};

export const Counterparty = {
    getAll: () => requests.get(`/counterparty`),
    getById: id => requests.get(`/counterparty/getbyid/${id}`),
    getByName: query => requests.get(`/counterparty/getbyname/${query}`),
    create: data => requests.post(`/counterparty/create`, { data }),
    delete: id => requests.del(`/counterparty/delete/${id}`)
};

export const Company = {
    getAll: () => requests.get(`/companies`),
    delete: id => requests.del(`/companies/delete/${id}`),
    create: data => requests.post(`/companies/create`, { data })
};

export const Credit = {
    getAll: conditions =>
        requests.get("/credits/get?" + encodeConditions(conditions)),
    edit: (id, data) => requests.post(`/credits/edit/${id}`, { data }),
    getById: id => requests.get(`/credits/${id}`),
    addComment: (creditId, data) =>
        requests.post(`/credits/comment`, { creditId, data }),
    create: (data, transactions) =>
        requests.post(`/credits/create`, { data, transactions }),
    prolongate: (creditId, data, transactions) =>
        requests.post(`/credits/prolongate`, { creditId, data, transactions }),
    close: (creditId, data, transactions) =>
        requests.post(`/credits/close`, { creditId, data, transactions }),
    increase: (creditId, newSum, date, transactions) =>
        requests.post(`/credits/increase`, {
            creditId,
            newSum,
            date,
            transactions
        }),
    decrease: (creditId, newSum, date, transactions) =>
        requests.post(`/credits/decrease`, {
            creditId,
            newSum,
            date,
            transactions
        })
};

export const Template = {
    getAll: () => `${ROOT}/zip/templates/?token=${token}`,
    upload: (name, files, onProgress) =>
        requests.upload(`/templates/upload`, name, files, onProgress)
};

export const CustomError = {
    add: data =>
        superagent
            .post(`${API_ROOT}/errors`, { data })
            .use(tokenPlugin)
            .then(responseBody)
};

export const src = {
    doc: doc => `${ROOT}/doc/${doc}?token=${token}`,
    captcha: () => requests.get("/fnp"),
    thumb: doc => `${ROOT}/thumb/${doc}?token=${token}`,
    zip: carId => `${ROOT}/zip/${carId}?token=${token}`,
    instruction: () => `${ROOT}/zip/instruction/?token=${token}`,
    print: (doc, id) => `${API_ROOT}/print/${doc}/${id}?token=${token}`,
    printNew: (doc, id, sum) =>
        `${API_ROOT}/print/${doc}/${id}/${sum}/?token=${token}`,
    printLT: (doc, id, managerId, lt) =>
        `${API_ROOT}/print/${doc}/${id}/${managerId}/${lt}?token=${token}`,
    printReport: (doc, start, end) =>
        `${API_ROOT}/print/${doc}/${start}/${end}?token=${token}`,
    printCalculatedLoan: programDetails =>
        `${API_ROOT}/print/loan_calculate/?${encodeConditions(
            programDetails
        )}&token=${token}`,
    printAgreement: ({
        lastname,
        firstname,
        patronymic,
        birthDate,
        passportSerie,
        passportNumber
    }) =>
        `${API_ROOT}/print/agreement/${firstname}/${lastname}/${patronymic}/${birthDate}/${passportSerie}/${passportNumber}?token=${token}`,
    printTransactionReport: filters =>
        `${API_ROOT}/print/transactions/?${encodeConditions(
            filters
        )}&token=${token}`
};

export const setToken = _token => {
    token = _token;
};



// WEBPACK FOOTER //
// ./src/agent.js